import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../js/hooks/useAuth";
import { isOnboardingPath, resolvePostAuthPath } from "../../js/auth/onboardingState";
import { postLoginPath } from "../../js/utils/siteLinks";

/**
 * Keeps signed-in users on the onboarding chain until complete.
 * Allows account settings and onboarding routes during the flow.
 */
export default function OnboardingGate({ children }) {
  const { session } = useAuth();
  const { pathname } = useLocation();

  if (!session?.userId) return children;
  if (session.role === "admin") return children;
  if (isOnboardingPath(pathname)) return children;
  if (pathname.startsWith("/account")) return children;

  const target = resolvePostAuthPath(session);
  const desk = postLoginPath(session);
  if (target !== desk && pathname !== target) {
    return <Navigate to={target} replace />;
  }

  return children;
}
